import { brandColor } from "./brand";

/** Shared breakpoints for responsive layout (min-width for "up" queries). */
export const breakpoints = {
  sm: "500px",
  /** Layout/nav mobile: NavigationBar hides and Header hamburger shows at/below this. Single source of truth. */
  layoutMobile: "720px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
} as const;

export const baseTheme = {
  breakpoints,
  color: {
    card: brandColor("white"),
    cardFg: brandColor("gray", 900),

    muted: brandColor("gray", 100),
    mutedFg: brandColor("gray", 700),

    border: brandColor("gray", 300),

    primary: brandColor("lionYellow"),
    primaryFg: brandColor("black"),

    accent: brandColor("lionBlue"),
    accentFg: brandColor("white"),

    success: brandColor("green"),
    successFg: brandColor("white"),

    warning: brandColor("yellow"),
    warningFg: brandColor("black"),

    danger: brandColor("red"),
    dangerFg: brandColor("white"),

    info: brandColor("blue"),
    infoFg: brandColor("white"),

    ring: brandColor("blue"),

    /** Default header background (same for light and dark mode). */
    headerBg: brandColor("darkBlue", 600),
    /** Default header bottom border gradient: start (left). */
    headerBorderGradientStart: brandColor("blueHighlight", 600),
    /** Default header bottom border gradient: end (right). */
    headerBorderGradientEnd: brandColor("darkBlue", 600),
  },
  radius: {
    md: "10px",
  },
  space: {
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
  },
};
